import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function BookingCancel() {
  return (
    <div className="max-w-2xl mx-auto px-5 md:px-8 py-24 text-center">
      <div className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center mx-auto">
        <XCircle className="w-8 h-8 text-amber-600" />
      </div>
      <h1 className="mt-6 font-heading text-3xl font-bold text-[#1B3A6B]">Payment cancelled</h1>
      <p className="mt-4 text-slate-600">No worries — your booking is on hold. You can resume anytime.</p>
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/book"><Button className="bg-[#1B3A6B] hover:bg-[#152D54] text-white rounded-full px-6 h-11">Resume booking</Button></Link>
        <Link to="/"><Button variant="outline" className="rounded-full px-6 h-11">Back to home</Button></Link>
      </div>
    </div>
  );
}
